import { Permissions } from '../../../../models/enums/permissions';
import * as React from 'react';
import { ClearButton } from '../../../../components/button/ClearButton';
import { HasPermission } from '../../../../containers/authorization-helpers/HasPermission';
import { SearchOrderSummary } from '../../../../models/ordering/search-order-summary';
import { formatCurrency } from '../../../../utils/currency-formatter';

interface IProps {
    onInvoice: (order: SearchOrderSummary) => void;
    order: SearchOrderSummary;
}

export const BillingOnlyOrderRow = (props: IProps) => (
    <tr>
        <td>{ props.order.id }</td>
        <td>{ props.order.dealerName }</td>
        <td>{ props.order.quantity }</td>
        <td>{ props.order.description }</td>
        <td>{ props.order.jobName }</td>
        <td>{ formatCurrency(props.order.amount) }</td>
        <td className="action-cell-icons action-cell-center">
            <HasPermission requiredPermissions={[
                Permissions.InvoicingBillingOnlyInvoice]}>
                <ClearButton
                    id={ 'billingonlyrow-' + props.order.id }
                    text="Invoice"
                    classes="action"
                    onBtnClick={ () => props.onInvoice(props.order) }
                    icon="" />
            </HasPermission>
        </td>
    </tr>
);
